module.exports = __webpack_public_path__ + "img/81ne.e53bb3ed.svg";